export const MAX_AGENDA_RANGE_MONTHS = 3;
export const MAX_OCCURRENCE_SCAN_DAYS = 366;